/*
 * Created on Thu Oct 12 2023 10:24:49 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { useEffect } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import FlexOfficeFooter from '../components/FlexOfficeFooter';
import FlexOfficeHeader from '../components/FlexOfficeHeader';
import { MeetingScheduler } from '../components/MeetingScheduler';

const BookSchedule = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Add smooth transition effect
  useEffect(() => {
    document.body.style.transition = 'all 0.3s ease';
    return () => {
      document.body.style.transition = '';
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header with reduced spacing */}
      <FlexOfficeHeader />

      {/* Main content with improved spacing and container */}
      <main className="flex-grow">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Breadcrumb navigation */}
          <nav className="mb-6" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-2 text-sm text-gray-600">
              <li>
                <a href="/" className="hover:text-blue-600 transition-colors">Home</a>
              </li>
              <li>
                <span className="text-gray-400">/</span>
              </li>
              <li>
                <a href="/book" id="book-schedule-link" className="hover:text-blue-600 transition-colors" aria-current="page">
                  Book Schedule
                </a>
              </li>
            </ol>
          </nav>

          {/* Helpful introductory text */}
          {/* <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Book Your Workspace
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Select your preferred time and workspace configuration. Our system will guide you through the process.
            </p>
          </div> */}

          {/* Main scheduler component with loading state handling */}
          <div className="bg-white rounded-xl shadow-sm p-1 sm:p-4 border border-gray-200">
            <MeetingScheduler />
          </div>

          {/* Help section */}
          <div className="mt-8 bg-blue-50 rounded-xl p-6 border border-blue-100">
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Need Help?</h2>
            <p className="text-gray-600 mb-4">
              If you have any questions about booking or our workspaces, please don't hesitate to contact us.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/contact"
                id="contact-support-link"
                className="px-4 py-2 bg-white border border-blue-500 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors text-center"
              >
                Contact Support
              </a>
              <a
                href="/faq"
                id="view-faqs-link"
                className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-center"
              >
                View FAQs
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* Footer with reduced spacing */}
      <FlexOfficeFooter />
    </div>
  );
};

export default BookSchedule;
